if (!customElements.get('model-parts')) {
  class ComponentModelParts extends HTMLElement {
    constructor() {
      super();
      this.searchForm = this.querySelector('#search-parts-form');
      this.searchField = this.searchForm ? this.searchForm.querySelector('input[name="part"]') : false;
      if(this.searchField != false){
        this.searchTargets = this.querySelectorAll('.search-target');
        this.quickViewBtns = this.querySelectorAll('.quick-view-trigger')
        this.quickViewBtns.forEach((item) => {
          item.addEventListener('click', this.openQuickView.bind(this))
        });
        this.partRows = this.querySelectorAll('#parts-list .part-row');
        this.allSelectPart = this.querySelectorAll('#parts-list .select-part');
        this.atcStickyPanel = this.querySelector('atc-sticky-panel');
        this.invalidWarrantyMessage = this.dataset.invalidWarrantyMessage;
        
        this.addToCartBtn = this.atcStickyPanel.querySelector('.btn.add');
        this.clearBtn = this.atcStickyPanel.querySelector('.clear-selections');
        
        this.quantityToAdd = 0;
        this.totalPrice = 0;
        
        this.allSelectPart.forEach((item) => {
          var check = item.querySelector('.select-part-check');
          check.addEventListener('change', this.onCheck.bind(this));

          var qtyField = item.querySelector('.quantity-input');
          qtyField.addEventListener('change', this.updateQuantityToAdd.bind(this));
        });

        this.searchForm.addEventListener('submit', this.doSearch.bind(this));
        this.searchField.addEventListener('input', this.doSearch.bind(this));

        this.addToCartBtn.addEventListener('click', this.addToCart.bind(this));

        this.clearBtn.addEventListener('click', this.clearSelections.bind(this));

        this.toggleAtcStickyPanel();
      }
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = e.currentTarget.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    doSearch(e) {
      e.preventDefault();
      e.stopPropagation();

      var term = this.searchField.value;
      this.searchTargets.forEach((item) => {
        if(term == "" || item.innerHTML.toLowerCase().includes(term.toLowerCase())){
          item.closest('.table-row').style.display = '';
        }else{
          item.closest('.table-row').style.display = 'none';
        }
      });
    }

    onCheck(e) {
      const item = e.target.closest('.select-part');
      const qtyField = item.querySelector('.quantity-input');
      const variantIdField = item.querySelector('.variant-id');
      const enabled = e.target.checked;
      
      if(enabled) {
        item.closest('.select-part').querySelector('.quantity-box').classList.remove('hide');
        qtyField.removeAttribute('disabled');
        qtyField.setAttribute('name', qtyField.dataset.name);
        variantIdField.removeAttribute('disabled');
        variantIdField.setAttribute('name', variantIdField.dataset.name);
        var maxQtyField = item.querySelector('.max-qty');
        maxQtyField.removeAttribute('disabled');
        maxQtyField.setAttribute('name', maxQtyField.dataset.name);

        var validWarrantyField = item.querySelector('.valid-warranty');
        if(validWarrantyField) {
          validWarrantyField.removeAttribute('disabled');
          validWarrantyField.setAttribute('name', validWarrantyField.dataset.name);
        }
      } else {
        item.closest('.select-part').querySelector('.quantity-box').classList.add('hide');
        qtyField.setAttribute('disabled', true);
        qtyField.removeAttribute('name');
        variantIdField.setAttribute('disabled', true);
        variantIdField.removeAttribute('name');
        var maxQtyField = item.querySelector('.max-qty');
        maxQtyField.setAttribute('disabled', true);
        maxQtyField.removeAttribute('name');
        var validWarrantyField = item.querySelector('.valid-warranty');
        if(validWarrantyField) {
          validWarrantyField.setAttribute('disabled', true);
          validWarrantyField.removeAttribute('name');
        }
      }

      this.updateQuantityToAdd();
      this.toggleAtcStickyPanel();
    }

    updateQuantityToAdd(e) {
      this.totalPrice = 0;
      this.quantityToAdd = 0;
      this.allSelectPart.forEach((item) => {
        if(!item.querySelector('.quantity-input').disabled) {
          this.quantityToAdd = this.quantityToAdd + item.querySelector('.quantity-input').value * 1;
          this.totalPrice = this.totalPrice + item.querySelector('.quantity-input').value * item.querySelector('.quantity-input').dataset.unitPrice;
        }
      });
      this.atcStickyPanel.querySelector('#total-qty').innerHTML = this.quantityToAdd;

      this.atcStickyPanel.querySelector('.btn.add .total-price').innerHTML = $s.formatMoney(this.totalPrice);
    }

    toggleAtcStickyPanel() {
      if (this.quantityToAdd > 0) {
        this.atcStickyPanel.classList.add('open');
      } else {
        this.atcStickyPanel.classList.remove('open');
      }
    }

    addToCart(e) {
      this.clearBtn.click();
    }

    clearSelections(e) {
      this.allSelectPart.forEach((item) => {
        var check = item.querySelector('.select-part-check');
        var qtyField = item.querySelector('.quantity-input');
        var variantIdField = item.querySelector('.variant-id');
        check.checked = false;
        item.closest('.select-part').querySelector('.quantity-box').classList.add('hide');
        qtyField.setAttribute('disabled', true);
        qtyField.removeAttribute('name');
        variantIdField.setAttribute('disabled', true);
        variantIdField.removeAttribute('name');
      });
      this.updateQuantityToAdd();
      this.toggleAtcStickyPanel();
    }

  }
  customElements.define('model-parts', ComponentModelParts);
}
